import { camelToTitleCase } from '../utils/camelToTitleCase.js';

export const formatAttributeKey = (str) => {
  if (str === undefined) {
    return undefined;
  }
  const parts = String(str).split('.');
  const last = parts.pop();
  return camelToTitleCase(last);
};
